export default {
  search: {
    placeholder: 'Search products...',
    button: 'Search',
    photo: 'Search by photo',
  },
  suggest: {
    history: 'History',
    category: 'Category',
    brand: 'Brand',
    article: 'Article',
    product: 'Product',
  },
  filters: {
    title: 'Filters',
    category: 'Category',
    gender: 'Gender',
    color: 'Color',
    size: 'Size',
    price: 'Price',
    priceFrom: 'from',
    priceTo: 'to',
    reset: 'Reset filters',
    apply: 'Apply',
    clear: 'Clear',
  },
  results: {
    found: '{count} {count, plural, one{product} other{products}} found',
    notFound: 'Nothing found',
    notFoundHint: 'Try changing your query or resetting filters',
  },
  crop: {
    search: 'Find similar',
    cancel: 'Cancel',
    hint: 'Select an area on the image',
  },
  error: {
    title: 'An error occurred',
    text: 'Failed to load results. Please try again later.',
    retry: 'Retry',
  },
  panel: {
    close: 'Close',
  },
};
